<template>
  <div class="card">
    <div class="card-body add-alarm-container">
      <form @submit.prevent="submit">
        <LoadingPlugin
          :active.sync="isLoading"
          :is-full-page="fullPage"
          background-color="#f3f3f3"
          :opacity="0.8"
          loader="bars"
        ></LoadingPlugin>

        <SuccessModal
          :show="showSuccessPopup"
          @close="showSuccessPopup = false"
          :msg="$t('success_msg_alarm_edit')"
          :heading="$t('success_heading_alarm_edit')"
        />

        <div class="add-alarm">
          <div class="row">
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <div
                  class="d-flex justify-content-between align-items-center mb-2"
                >
                  <label>{{ $t("alarm_name") }}</label>

                  <div class="d-flex align-items-center mb-0">
                    <input type="checkbox" v-model="notifyWhenNormal" />
                    <p class="gray4 ml-2">
                      {{ $t("notif_when_back_to_normal") }}
                    </p>
                  </div>
                </div>
                <input
                  type="text"
                  name="name"
                  v-model="title"
                  class="form-control"
                  required
                />
              </div>

              <div class="form-group">
                <label>{{ $t("temp_value") }}</label>

                <div class="d-flex col-gap-1 justify-content-between">
                  <input
                    type="number"
                    name="name"
                    v-model.number="temperature.min"
                    class="form-control"
                    :placeholder="$t('enter_min_temp')"
                    :required="temperature.max"
                  />

                  <input
                    type="number"
                    name="name"
                    v-model.number="temperature.max"
                    class="form-control"
                    :placeholder="$t('enter_max_temp')"
                    :required="temperature.min"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>{{ $t("humid_value") }}</label>
                <div class="d-flex col-gap-1 justify-content-between">
                  <input
                    type="number"
                    name="name"
                    v-model.number="humidity.min"
                    class="form-control"
                    :placeholder="$t('enter_min_humid')"
                    :required="humidity.max"
                  />

                  <input
                    type="number"
                    name="name"
                    v-model.number="humidity.max"
                    class="form-control"
                    :placeholder="$t('enter_max_humid')"
                    :required="humidity.min"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>{{ $t("battery_value") }}</label>
                <div class="d-flex col-gap-1 justify-content-between">
                  <input
                    type="number"
                    name="name"
                    v-model.number="battery.min"
                    class="form-control"
                    :placeholder="$t('enter_min_battery')"
                    :required="battery.max"
                  />

                  <input
                    type="number"
                    name="name"
                    v-model.number="battery.max"
                    class="form-control"
                    :placeholder="$t('enter_max_battery')"
                    :required="battery.min"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>{{ $t("geo") }}</label>
                <!-- <input
                type="text"
                name="name"
                v-model="geofenceData.id"
                class="form-control"
                required
              /> -->
                <select
                  name="poi"
                  class="form-control"
                  v-model="geofenceData.id"
                >
                  <option value="">
                    {{ $t("select") }}
                  </option>
                  <option
                    v-for="data in geofence"
                    :key="data.id"
                    :value="data.id"
                    >{{ data.name }}</option
                  >
                </select>

                <div class="d-flex col-gap-2 align-items-center mt-2">
                  <div class="d-flex align-items-center">
                    <input
                      type="checkbox"
                      v-model="geofenceData.notifyWhenIn"
                    />
                    <p class="gray4 ml-2">
                      {{ $t("notif_when_in_geo") }}
                    </p>
                  </div>
                  <div class="d-flex align-items-center">
                    <input
                      type="checkbox"
                      v-model="geofenceData.notifyWhenOut"
                    />
                    <p class="gray4 ml-2">
                      {{ $t("notif_when_out_geo") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <div
                  class="d-flex justify-content-between align-items-center mb-2"
                >
                  <label>{{ $t("time_int") }}</label>
                </div>
                <select
                  name="device"
                  class="form-control"
                  v-model="intervalMinutes"
                  required
                >
                  <option
                    v-for="{ label, value } in timeInterval"
                    :key="value"
                    :value="value"
                    >{{ label }}</option
                  >
                </select>
              </div>

              <ComboBox
                :data="sorteddevices"
                :isItemChecked="(device) => selecteddevices.includes(device.id)"
                @checkClick="(device) => updateDevice(device)"
                @doSearch="doSearch"
                :isSelectAll="
                  selecteddevices.length === allSortedDevices.length
                "
                :selectAll="
                  () => (selecteddevices = allSortedDevices.map(({ id }) => id))
                "
                :deSelectAll="() => (selecteddevices = [])"
                :label="$t('add_devices')"
              />

              <ComboBox
                :data="sortedusers"
                :isItemChecked="(user) => selectedusers.includes(user.id)"
                @checkClick="(user) => updateUser(user)"
                @doSearch="doSearchUser"
                :isSelectAll="sortedusers.length === selectedusers.length"
                :selectAll="
                  () => (selectedusers = allSortedUsers.map(({ id }) => id))
                "
                :deSelectAll="() => (selectedusers = [])"
                :label="$t('add_users_staff_email')"
              />

              <ComboBox
                :data="sortedPhones"
                :isItemChecked="
                  (phone) => selectedPhones.includes(phone.phoneId)
                "
                @checkClick="(phone) => updatePhone(phone)"
                @doSearch="doSearchPhone"
                :isSelectAll="sortedPhones.length === selectedPhones.length"
                :selectAll="
                  () =>
                    (selectedPhones = allSortedPhones.map(
                      ({ phoneId }) => phoneId
                    ))
                "
                :deSelectAll="() => (selectedPhones = [])"
                :label="$t('sms_whatsapp_notif')"
              />

              <div class="form-group">
                <label>{{ $t("POI") }}</label>
                <!-- <input
                type="text"
                name="name"
                v-model="poiData.id"
                class="form-control"
                required
              /> -->
                <select name="poi" class="form-control" v-model="poiData.id">
                  <option value="">
                    {{ $t("select") }}
                  </option>
                  <option v-for="data in POI" :key="data.id" :value="data.id">{{
                    data.name
                  }}</option>
                </select>

                <div class="d-flex col-gap-2 align-items-center mt-2">
                  <div class="d-flex align-items-center">
                    <input type="checkbox" v-model="poiData.notifyWhenIn" />
                    <p class="gray4 ml-2">
                      {{ $t("notif_when_in_poi") }}
                    </p>
                  </div>
                  <div class="d-flex align-items-center">
                    <input type="checkbox" v-model="poiData.notifyWhenOut" />
                    <p class="gray4 ml-2">
                      {{ $t("notif_when_out_poi") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div
              class="d-flex align-items-center justify-content-end col-gap-1 w-100"
            >
              <button
                class="btn btn-primary"
                type="submit"
                :disabled="!atLeastOneAlarmType"
              >
                {{ $t("save") }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ComboBox from "../../components/ComboBox.vue";
import LoadingPlugin from "vue-loading-overlay";
import SuccessModal from "../Modals/SuccessModal.vue";
export default {
  name: "AlarmSettings",
  props: {
    step: Number,
  },
  computed: {
    ...mapGetters([
      "alarms",
      "profile",
      "devices",
      "users",
      "geofence",
      "POI",
      "alarm",
    ]),
    atLeastOneAlarmType() {
      return (
        !!this.temperature.min ||
        !!this.humidity.min ||
        !!this.geofenceData.id ||
        !!this.poiData.id
      );
    },
  },
  data() {
    return {
      isLoading: false,
      fullPage: false,
      sorteddevices: [],
      allSortedDevices: [],
      selecteddevices: [],

      sortedusers: [],
      allSortedUsers: [],
      selectedusers: [],

      sortedPhones: [],
      allSortedPhones: [],
      selectedPhones: [],
      webhook: "",
      selectedIndex: 0,
      show: false,
      isShow: false,
      selectedIndexes: [],
      title: "",
      temperature: {
        min: null,
        max: null,
        notifyWhenNormal: true,
      },
      humidity: {
        min: null,
        max: null,
        notifyWhenNormal: true,
      },
      battery: {
        min: null,
        max: null,
        notifyWhenNormal: true,
      },
      poiData: {
        id: "",
        notifyWhenIn: true,
        notifyWhenOut: true,
      },
      geofenceData: {
        id: "",
        notifyWhenIn: true,
        notifyWhenOut: true,
      },
      timeInterval: [
        // { label: "5 mins", value: 5 },
        // { label: "15 mins", value: 15 },
        { label: "30 mins", value: 30 },
        { label: "45 mins", value: 45 },
        { label: "1 hr", value: 60 },
        { label: "2 hrs", value: 120 },
        { label: "4 hrs", value: 240 },
        { label: "6 hrs", value: 360 },
        { label: "12 hrs", value: 720 },
        { label: "24 hrs", value: 1440 },
      ],
      intervalMinutes: "",
      notifyWhenNormal: true,
      showSuccessPopup: false,
    };
  },
  mounted() {
    this.sorteddevices = this.devices
      // .filter((device) => !device.group)
      .map(({ settings, ...rest }) => ({
        name: settings.name,
        settings,
        ...rest,
      }));
    this.allSortedDevices = this.sorteddevices;

    // let activeusers = this.singlegroup.users.map((user) => user.email);
    this.sortedusers = this.users
      //   .filter((user) => !activeusers.includes(user.email))
      .map(({ email, ...rest }) => ({
        name: email,
        email,
        ...rest,
      }));
    this.allSortedUsers = this.sortedusers;

    this.sortedPhones = this.users
      //   .filter((user) => !activeusers.includes(user.email))
      .map(({ phone, id, ...rest }) => ({
        name: phone,
        phone,
        phoneId: id,
        ...rest,
        id: phone,
      }));
    this.allSortedPhones = this.sortedPhones;
  },
  methods: {
    ...mapActions(["updateAlarm", "getAlarmById"]),
    updateDevice(val) {
      const index = this.selecteddevices.indexOf(val.id);

      if (index !== -1) {
        // If the deviceTag is already in the array, remove it
        this.selecteddevices.splice(index, 1);
      } else {
        // If the deviceTag is not in the array, add it along with deviceName
        this.selecteddevices = [...this.selecteddevices, val.id];
      }
    },
    doSearch({ target: { value } }) {
      const filtered = this.allSortedDevices.filter(
        ({ settings: { name }, group }) =>
          name.toLowerCase().includes(value.toLowerCase())
      );
      this.sorteddevices = filtered;
    },
    doSearchUser({ target: { value } }) {
      //   let activeusers = this.singlegroup.users.map((user) => user.email);
      const filtered = this.users
        .filter((user) =>
          user.email.toLowerCase().includes(value.toLowerCase())
        )
        .map(({ email, ...rest }) => ({
          name: email,
          ...rest,
        }));
      this.sortedusers = filtered;
    },
    updateUser(val) {
      // const index = this.selectedusers.indexOf(val.email);
      const index = this.selectedusers.indexOf(val.id);
      if (index !== -1) {
        this.selectedusers.splice(index, 1);
      } else this.selectedusers = [...this.selectedusers, val.id];
    },

    doSearchPhone({ target: { value } }) {
      //   let activeusers = this.singlegroup.users.map((user) => user.email);
      const filtered = this.users
        .filter((user) =>
          user.phone.toLowerCase().includes(value.toLowerCase())
        )
        .map(({ phone, ...rest }) => ({
          name: phone,
          ...rest,
          id: phone,
        }));
      this.sortedPhones = filtered;
    },
    updatePhone(val) {
      const index = this.selectedPhones.indexOf(val.phoneId);
      if (index !== -1) {
        this.selectedPhones.splice(index, 1);
      } else this.selectedPhones = [...this.selectedPhones, val.phoneId];

      // const index = this.selectedPhones.findIndex(
      //   (item) => item.phone === val.phone
      // );

      // if (index !== -1) {
      //   // If the deviceTag is already in the array, remove it
      //   this.selectedPhones.splice(index, 1);
      // } else {
      //   // If the deviceTag is not in the array, add it along with deviceName
      //   this.selectedPhones = [
      //     ...this.selectedPhones,
      //     { phone: val.phone, name: val.fullname, id: val.phoneId },
      //   ];
      // }
    },
    toggleAccordion(index) {
      // this.selectedIndex = this.selectedIndex === index ? -1 : index;
      if (this.selectedIndexes.includes(index)) {
        this.selectedIndexes = this.selectedIndexes.filter(
          (idx) => idx !== index
        );
      } else this.selectedIndexes = [...this.selectedIndexes, index];
    },
    submit() {
      const payload = {
        title: this.title,
        devices: this.selecteddevices,
        temperature: this.temperature.min ? this.temperature : undefined,
        humidity: this.humidity.min ? this.humidity : undefined,
        battery: this.battery.min ? this.battery : undefined,
        notifyWhenNormal: true,
        poi: this.poiData.id ? this.poiData : undefined,
        geofence: this.geofenceData.id ? this.geofenceData : undefined,
        intervalMinutes: this.intervalMinutes,
        notify: {
          phoneUsers: this.selectedPhones?.length
            ? this.selectedPhones
            : undefined,
          emailUsers: this.selectedusers?.length
            ? this.selectedusers
            : undefined,
          webhookURL: this.webhook ? this.webhook : undefined,
          // webhookURL: this.webhook,
        },
        company: this.alarm.company,
      };

      this.isLoading = true;
      this.updateAlarm({ id: this.$route.params.alarmId, newValue: payload })
        .then(() => {
          this.showSuccessPopup = true;
          this.getAlarmById(this.$route.params.alarmId).then(() => {
            this.isLoading = false;
          });
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            //console.log(error.response.data.message);
          }
        });
    },
  },
  components: {
    ComboBox,
    LoadingPlugin,
    SuccessModal,
  },
  watch: {
    alarm: {
      handler() {
        const {
          title,
          devices,
          temperature,
          humidity,
          battery,
          notifyWhenNormal,
          poi,
          geofence,
          hummidity,
          settings: { intervalMinutes },
          notify: { emails, phones },
        } = this.alarm;

        console.log(intervalMinutes, "intervalMinutes");
        this.title = title;
        if (temperature) {
          this.temperature = temperature;
        }
        if (humidity) this.humidity = hummidity;
        if (battery) this.battery = battery;
        this.notifyWhenNormal = notifyWhenNormal;
        if (geofence) this.geofenceData = geofence;
        if (poi) this.poiData = poi;
        this.selecteddevices = devices;
        this.selectedPhones = phones;
        this.selectedusers = emails;
        this.intervalMinutes = intervalMinutes;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 0;
}

.step-3 .card {
  border-radius: 12px;
  background: #fff;

  /* Style 2 */
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
}
/* .slide-enter-active,
  .slide-leave-active {
    transition: max-height 3.5s;
  }
  .slide-enter-from {
    max-height: 0;
  }
  .slide-leave-to {
    max-height: 100px;
  }
  
  .slide-fade-enter-active {
    transition: all 0.3s ease-out;
  }
  
  .slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }
  
  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: translateX(20px);
    opacity: 0;
  } */

ul {
  cursor: pointer;
}

.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}

/* @media (min-width: 768px) {
    .add-alarm {
      padding: 1rem;
    }
  }
  
  @media (min-width: 1600px) {
      .add-alarm {
      padding: 2rem;
    }
  } */

@media (min-width: 768px) {
  .add-alarm-container {
    padding: 20px 2rem;
  }
}

@media (min-width: 1600px) {
  .add-alarm-container {
    padding: 40px 3rem;
  }
}
/* @media (min-width: 1600px) {
  .add-alarm-container {
    padding: 0 2rem;
  }
} */
</style>
